import { makeStyles } from '@material-ui/core/styles';
import { backgroundDark } from '../../../../styles/themes/palettes/dark';
import { backgroundLight } from '../../../../styles/themes/palettes/light';

const styles = makeStyles(theme => ({
  container: {
    padding: theme.spacing(3),
    ...theme.typography.body2,
    wordBreak: 'break-word',

    '&.light': {
      backgroundColor: backgroundLight,
    },
    '&.dark': {
      backgroundColor: backgroundDark,
    },
    '&:not(.light):not(.dark)': {
      color: theme.palette.text.secondary,
    },
    '& *': {
      maxWidth: '100%',
    },
    '& iframe:not(.no-force-resize)': {
      width: '100%',
      height: '52vw',
      maxHeight: '55vh',
    },
  },
}));

export default styles;
